<div class="filter-tray">
    <div class="tray-items" [formGroup]="byAssignedForm">
        <div formArrayName="assignedUsers">
            <div class="tray-row" *ngFor="let assignedCtrl of assignedUsers.controls; let i = index">
                <single-choice
                    [formControl]="assignedCtrl"
                    (click)="setEditingIndex(i)"
                    [completedUrl]="completionUrl"
                    [topic]="'users'"
                    [editMode]="true"
                    [ticketId]="fakeId"
                    [icon]="'person'"
                    (choiceEvent)="relaySingleChoice($event)"
                    [labelOnDemand]="assignedLabelerByService"
                    [choiceObserver]="assignedObserver">
                </single-choice>
                <button type="button" class="row-remove" (click)="removeField(i)" [disabled]="assignedUsers.length <= 1">
                    <i class="material-icons-outlined">close</i>
                </button>
            </div>
        </div>
    </div>
    <div class="tray-footer">
        <button type="button" class="add-btn" (click)="addAssignedField()">
            <i class="material-icons-outlined">add</i>
        </button>
        <not [filter]="byAssignedFilter" (filterChanged)="onFilterChanged($event)"></not>
        <button class="apply-btn" type="button" (click)="apply()">{{ 'filter.apply' | translate }}</button>
    </div>
</div>
